import styled from 'styled-components';
import {CSS_CONSTANTS} from '../../css_variables';

export const ProjectIdChipStyled = styled.div`
	display: flex;
	justify-content: center;

	height: 20px;
	width: fit-content;
	min-width: 50px;
	padding: 0 8px;
	border-radius: 6px;
	flex-shrink: 0;
	font-size: 10px;
	font-weight: 500;
	line-height: 20px;
	margin-right: 16px;
	color: ${props => (props.useDarkText ? CSS_CONSTANTS['$v2-text-gray'] : 'white')};
	background-color: ${props => props.projectColor};

	/* i do not think we are using this icon anymore */
	/* &.project-group {
		padding-left: 26px;
		background-image: url('images/components/scheduling/connected-project-icon-white.svg');
		background-size: 14px;
		background-repeat: no-repeat;
		background-position: left 8px center;
	} */
`;
